import React from 'react';
import styled, { css } from 'styled-components';
import { theme } from 'utils/style/theme';
/**
 * * 기본 버튼
 */

interface IProps {
  children: string | React.ReactElement;
  textColor?: string;
  backColor?: string; // 버튼 배경 색
  name?: string;
  disabled?: boolean;
  style?: React.CSSProperties;
  hoverColor?: string | null;
  typename?: 'del' | 'goBack' | 'subordinate' | 'sub' | string | undefined; // 버튼 백그라운드 컬러 변경을 위한 prop
  onClick?: (e: React.MouseEvent) => void;
}
const DefaultButton = ({
  textColor,
  backColor,
  children,
  onClick,
  disabled,
  name,
  style,
  typename,
  ...props
}: IProps) => {
  return (
    <Button
      name={name}
      disabled={disabled}
      onClick={onClick}
      style={style}
      typename={typename}
      textColor={textColor}
      backColor={backColor}
      {...props}
    >
      {children}
    </Button>
  );
};

DefaultButton.defaultProps = {
  children: '등록하기',
};
export default DefaultButton;

const Button = styled.button<IProps>`
  padding: 0.65rem 1.2rem;

  background-color: ${(props) =>
    props.backColor ? `${props.backColor}` : `${theme.colors.primary}`};
  box-shadow: 2px 1.5px 2px 0.2px rgb(0 0 0 / 15%);
  margin-left: 0.8rem;
  color: ${(props) =>
    props.textColor
      ? props.textColor
      : props.disabled
      ? theme.colors.gray_2
      : '#fff'};

  border-radius: 0.3rem;
  font-weight: 600;
  cursor: ${(props) => (props.disabled ? `not-allowed` : `pointer`)};
  transition: 0.25s;

  //* TODO: hover 일 때 효과 넣기 */
  &:hover {
    background-color: ${theme.colors.blueText};
    box-shadow: 2px 1.5px 2px 0.2px rgb(0 0 0 / 30%);
    background-position: 100% 0%;
    /* moz-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  -webkit-transition: all 0.4s ease-in-out; */
    transition: all 0.2s ease-in-out;
  }
  /* 등록 이외의 버튼 */
  ${(props) =>
    props.typename === 'sub' &&
    css`
      background-color: ${theme.colors.sub};
    `}

  ${(props) =>
    props.typename === 'info' &&
    css`
      background-color: ${theme.colors.blue_04};
      border-radius: 5rem;
    `}
  ${(props) =>
    props.typename === 'goBack' &&
    css`
      background-color: ${theme.colors.table_button};
      color: ${theme.colors.blueText};
      border-radius: 5rem;
    `}
    ${(props) =>
    props.typename === 'search' &&
    css`
      border-radius: 5rem;
      background-color: ${theme.colors.blue_04};
    `}

    ${(props) =>
    props.typename === 'subordinate' &&
    css`
      font-weight: 500;
      padding: 0.6rem 1rem;
      background-color: ${theme.colors.blue_2};
    `}
`;
